/**
 * create link
 * Created by peak on 16/8/18.
 */
import dashboard from "./dashboard.vue";
export default {
    name: "link",
    icon: "custom-icon link",
    show: true,
    i18n: "link",
    dashboard
}



// WEBPACK FOOTER //
// ./src/components/editor/src/modules/link/index.js